<template>
  <div class="checkbox-wrapper">
    <div class="checkbox" v-on:click="toggle">
      <img :src="require('@/assets/icons/v-blue.svg')" class="checkmark" v-if="checked">
    </div>
    <slot name="title"></slot>
  </div>
</template>

<script>

export default {
  name: 'CheckBox',
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    toggle: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/base-ui/src/scss/riseup-colors';

.checkbox-wrapper {
  display: flex;
  margin-bottom: 15px;
  width: 100%;

  .checkbox {
    height: 25px;
    width: 25px;
    border-radius: 4px;
    border: solid 1px #979797;
    cursor: pointer;
    .checkmark {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
